import firebaseApp from '../../../../services/firebaseService';
import { BasicBaseHelper, IBasicBaseClass } from '../../base';

export interface IPumpingStationPumpType extends IBasicBaseClass {
    name : string;

    isActive : boolean;
}

export default class PumpingStationPumpTypeHelper extends BasicBaseHelper {
    public static readonly COLLECTION_NAME = 'pumping_station_pump_type';

    private static converter : firebase.firestore.FirestoreDataConverter<IPumpingStationPumpType> = {
        fromFirestore: (snapshot) => {
            return PumpingStationPumpTypeHelper.fromFirestoreDocument(snapshot);
        },
        toFirestore: (data : IPumpingStationPumpType) : firebase.firestore.DocumentData => {
            return PumpingStationPumpTypeHelper.toFirestoreDocument(data);
        },
    };

    public static fromFirestoreDocument(snapshot : firebase.firestore.DocumentSnapshot) : IPumpingStationPumpType {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!snapshot.exists || !result || !data) throw new Error(`Document does not exist! ${snapshot.id}`);
        return {
            ...data as IPumpingStationPumpType,
            ...result,
        };
    }

    public static toFirestoreDocument(data : IPumpingStationPumpType) {
        const result = super.toFirestore(data);
        const { id: _id, ...rest } = data;

        return {
            ...rest,
            ...result,
        };
    }

    public static doc(id ?: string) {
        if (!id) {
            return firebaseApp.firestore().collection(PumpingStationPumpTypeHelper.COLLECTION_NAME).withConverter(PumpingStationPumpTypeHelper.converter).doc();
        }

        return firebaseApp.firestore().collection(PumpingStationPumpTypeHelper.COLLECTION_NAME).withConverter(PumpingStationPumpTypeHelper.converter).doc(id);
    }

    public static save(company : IPumpingStationPumpType) {
        return PumpingStationPumpTypeHelper.doc(company.id).set(company, {
            merge: true,
        });
    }
    
    public static collection() {
        return firebaseApp
            .firestore()
            .collection(PumpingStationPumpTypeHelper.COLLECTION_NAME)
            .withConverter(PumpingStationPumpTypeHelper.converter);
    }
}